import { useEffect, useRef, useState } from 'react';

import { EditPayrunApprovalRef } from '@xemplo/edit-payrun-approvers';

import {
  PayrunDetailApproverModalProps,
  PromptDialogRef,
} from './payrun-approvers-detail-modal.types';

export const usePayrunModalHelper = (props: Readonly<PayrunDetailApproverModalProps>) => {
  const { dialogProps, isOpen, onDelete, closeDialog, name, profilePhoto } = props;

  const [isEdit, setIsEdit] = useState<boolean>(false);

  //Reset edit mode when modal is closed to ensure new modal is always in view mode on open
  useEffect(() => {
    if (!isOpen) setIsEdit(false);
  }, [isOpen]);

  const deletePromptRef = useRef<PromptDialogRef>(null);
  const modalBodyRef = useRef<EditPayrunApprovalRef>(null);

  const [firstName, lastName] = name?.split(' ') ?? ['', ''];

  const handleEdit = () => {
    setIsEdit(true);
  };

  const handleCancel = () => {
    modalBodyRef.current?.handleResetForm();
    setIsEdit(false);
    closeDialog();
  };

  const onSubmit = () => {
    modalBodyRef.current?.handleFormSubmit();
    setIsEdit(false);
    closeDialog();
  };

  return {
    isModalOpen: isOpen,
    isEdit,
    dialogProps,
    handleCancel,
    handleEdit,
    onSubmit,
    onDelete,
    deletePromptRef,
    modalBodyRef,
    name,
    firstName,
    lastName,
    profilePhoto,
  };
};
